@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

#solutionsLink {
  cursor: pointer;
}
#solutionsOverlay {
  max-width: 1000px;
  height: 330px;
}
.ciSolutions {
  display: flex;
  justify-content: space-between;
  height: 100%;
  box-sizing: border-box;

  &-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    line-height: 1.5rem;
  }
  &-column {
    flex-grow: 1;
    width: 50%;
    padding: 1rem;
    box-sizing: border-box;
  }
  &-link {
    display: block;
    box-sizing: border-box;
    align-self: center;
    padding: 0.5rem;
    border-radius: 6px;
    color: $color-gray-obsidian;
    text-decoration: none;
    &:link, &:visited {
      color: $color-gray-obsidian;
    }
    &:hover {
      background: $color-header-hover-blue;
      .ciSolutions-title {
        color: $color-blue-default;
      }
    }
  }
  &-printfection {
    display: block;
    width: auto;
    height: 45px;
    margin-bottom: .5rem;
  }
  &-title {
    font-weight: 600;
    display: block;
    font-size: 1.05rem;
    margin-bottom: .15rem;
  }
  &-subtitle {
    display: block;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 1.3125rem;
  }
}
